// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import { default as ControlsContainer } from '@aytm/app/stats/page/question-views/components/component/Controls'

const Controls = ({ model, data, collapsed, onToggle }) => (
  <ControlsContainer data={data} collapsed={collapsed} onToggle={onToggle}>
    <div className="p-field" dangerouslySetInnerHTML={{ __html: model.script ? model.script.title : '' }}></div>
  </ControlsContainer>
)

Controls.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
